import { Skeleton, SkeletonDocumentCard } from './Skeleton';

/**
 * Loading skeleton for the Documents page
 */
export function DocumentsPageSkeleton() {
  return (
    <>
      {/* Filters Skeleton */}
      <div className="flex items-center gap-3 mb-6 flex-wrap">
        <Skeleton height={40} width={200} />
        <Skeleton height={40} width={150} />
        <Skeleton height={40} width={250} className="flex-1 max-w-xs" />
        <Skeleton height={16} width={80} />
      </div>

      {/* Document Grid Skeleton */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {Array.from({ length: 8 }).map((_, i) => (
          <SkeletonDocumentCard key={i} />
        ))}
      </div>
    </>
  );
}
